import { Component } from '@verndale/core';
import Headroom from 'headroom.js';
import { debounce } from 'lodash';
import { BREAKPOINTS } from '../constants';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      $header: this.el,
      $headerInner: this.el._$('.monogram-header__inner'),
      $hamburger: this.el._$('.monogram-header__hamburger'),
      $hamburgerMenu: this.el._$('.monogram-hamburger-menu'),
      $closeHamburger: this.el._$('.monogram-header__close'),
      $primaryNavItems: this.el._$$('.monogram-primary-nav__item'),
      $hamburgerMenuItems: this.el._$$('.monogram-hamburger-menu__item'),
      $contactUs: this.el._$$('.monogram-primary-nav__contact-us-trigger'),
      $banner: this.el._$('.monogram-header__banner'),
      $headerHolder: this.el._$('.monogram-header__items-holder')
    };

    this.panelOpenedClass = 'monogram-header--panel-opened';
    this.desktopHiddenClass = 'monogram-primary-nav__item--desktop-hidden';
    this.desktopMediaQuery = window.matchMedia('(min-width: 1200px)');
    this.isFullNav = this.desktopMediaQuery.matches;
    this.breakpoint = window.matchMedia(`(max-width: ${BREAKPOINTS.TABLET_LANDSCAPE - 1}px)`);
    this.expanded = false;
    this.itemsAppended = false;
    this.stick();
    this.setHeight();
    this.fixMac();
  }


  addListeners() {
    this.dom.$hamburger._on('click', this.handleHamburgerClick.bind(this));
    this.dom.$closeHamburger._on('click', this.handleCloseHamburgerClick.bind(this));
    this.dom.$contactUs._on('click', this.handleContactUsClick.bind(this));
    this.desktopMediaQuery.addEventListener('change', e => { this.isFullNav = e.matches });
    window.addEventListener('resize', debounce(this.setHeight.bind(this), 300));
  }

  fixMac(){
    if (navigator.userAgent.indexOf('Mac OS X') !== -1) {
      this.dom.$headerHolder?.classList.add('shadow-mac');
    }
  }

  appendToHamburger() {
    if (this.dom.$primaryNavItems.length > 5 && !this.itemsAppended) {
      const items = [];

      this.dom.$primaryNavItems.forEach(element => {
        items.push(`
        <div class="monogram-primary-nav__hamburguer-menu-link monogram-hamburger-menu__item">
          <a href="${element.firstElementChild.href}">
            ${element.firstElementChild.innerText}
            <svg viewBox="0 0 11 18" width="11" height="18" role="presentation">
              <use xlink:href="#arrow-right"></use>
            </svg>
          </a>
        </div>
        `);
        element.classList.add(this.desktopHiddenClass);
      });

      const firstMenuItem = this.dom.$hamburgerMenu.firstElementChild;
      const isMenuItem = firstMenuItem.classList.contains('monogram-hamburger-menu__item');

      if (!isMenuItem) {
        firstMenuItem.remove();
      }

      this.dom.$hamburgerMenu.innerHTML = `${isMenuItem ? '' : firstMenuItem.outerHTML}${items.join('')}${this.dom.$hamburgerMenu.innerHTML}`;
      this.itemsAppended = true;
    }
  }

  setHeight() {
    if (window.matchMedia(`(min-width: ${BREAKPOINTS.DESKTOP}px)`).matches) {
      if (this.dom.$hamburgerMenu) {
        const bannerHeight = this.dom.$banner ? this.dom.$banner.offsetHeight : 0
        const headerHeight = this.dom.$banner ? this.dom.$header.offsetHeight : this.dom.$headerInner.offsetHeight
        this.dom.$hamburgerMenu.style.height = `${window.innerHeight - headerHeight + bannerHeight}px`;
        this.appendToHamburger();
      }
    }

    // Hide main nav on desktop for Sky View pages (determined by no hamburger items)
    if (this.isFullNav && this.dom.$hamburgerMenuItems.length == 0) {
      this.dom.$hamburger.style.display = "none";
    } else {
      this.dom.$hamburger.style.display = "block";
    }
  }

  lockScroll() {
    if (this.breakpoint.matches){
      _$('html, body').style.overflow = 'hidden';
    }
  }

  unlockScroll() {
    _$('html, body').style.overflow = 'visible';
  }

  stick() {
    new Headroom(this.el, {
      offset: this.el.offsetTop,
      classes: {
        initial: 'monogram-header',
        pinned: 'monogram-header--visible',
        unpinned: 'monogram-header--hidden',
        top: '-',
        notTop: '-',
        bottom: '-',
        notBottom: '-',
        frozen: '-'
      },
      onPin: () => {
        const sidePanel = document.querySelector('header')
        if (!sidePanel?.classList.contains('monogram-header--panel-opened')){
          document.body.classList.add('monogram-header--visible');
          document.body.classList.remove('monogram-header--hidden');
        }
      },
      onNotTop: () => {
        document.body.classList.add('header--passed');
      },
      onTop: () => {
        document.body.classList.remove('header--passed');
      },
      onUnpin: () => {
        const sidePanel = document.querySelector('header')
        if (sidePanel?.classList.contains('monogram-header--panel-opened')){
          sidePanel.classList.remove('monogram-header--hidden');
          sidePanel.classList.add('monogram-header--visible');
        } else {
          sidePanel.classList.add('monogram-header--hidden');
          sidePanel.classList.remove('monogram-header--visible');
        }
      }
    }).init();
  }

  openPrimaryNavChildMenu() {
    this.el.classList.add(this.childMenuPanelOpenedClass);

    if (this.isFullNav) {
      document._on('mousedown', this.handleListenToOutsidePrimaryNavPanel.bind(this));
    }
  }

  closePrimaryNavChildMenu() {
    this.el.classList.remove(this.childMenuPanelOpenedClass);
    this.dom.$primaryNavItems.find(el => el.classList.contains(this.expandedPrimaryNavItemClass))?.classList.remove(this.expandedPrimaryNavItemClass);
  }

  scrollToHeader(scrollBehavior = 'smooth') {
    const topScrollPros = document.documentElement.scrollTop;
    const headerScrollPos = this.el.getBoundingClientRect().top + topScrollPros;
    if (topScrollPros < headerScrollPos) {
      window.scrollTo({ top: headerScrollPos, behavior: `${scrollBehavior}` });
    }
  }

  handleResize() {
    this.setHeight();
  }

  handleHamburgerClick() {
    this.expanded = !this.expanded
    this.dom.$hamburger.setAttribute('aria-expanded', this.expanded)

    this.el.classList.add(this.panelOpenedClass);
    if (!this.el.classList.contains('isExperienceEditor')) {
      this.lockScroll();
      this.scrollToHeader();
    }
    this.dom.$hamburgerMenu.focus()
  }

  handleCloseHamburgerClick() {
    this.expanded = !this.expanded
    this.dom.$hamburger.setAttribute('aria-expanded', this.expanded)

    this.el.classList.remove(this.panelOpenedClass);
    this.unlockScroll();
  }

  handleContactUsClick() {
    this.el.classList.remove(this.panelOpenedClass);
    this.unlockScroll();
  }
}

export default Module;
